import React from 'react';
import { Card, CardContent, Box, Typography, Chip } from '@mui/material';
import { LocationOn, Speed, ArrowForwardIos } from '@mui/icons-material';

export default function PlantCard({ plant, position, onClick }) {
  const distance = position && plant.gps_lat && plant.gps_lng
    ? haversine(position.latitude, position.longitude, plant.gps_lat, plant.gps_lng)
    : (position && plant.latitude && plant.longitude
      ? haversine(position.latitude, position.longitude, plant.latitude, plant.longitude)
      : null);

  const meterCount = plant.total_meters || plant.meter_count || plant.Meters?.length || 0;
  const codice = plant.plant_code || plant.nome || `#${plant.id}`;
  const citta = plant.citta || '';

  const distLabel = distance !== null && distance < Infinity
    ? (distance < 1 ? `${Math.round(distance * 1000)} m` : `${distance.toFixed(1)} km`)
    : null;

  return (
    <Card
      onClick={onClick}
      sx={{
        mb: 1.5, cursor: 'pointer', borderRadius: 2,
        '&:active': { transform: 'scale(0.98)' },
        transition: 'transform 0.1s'
      }}
    >
      <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
        {/* Top row: provincia tag + distance badge + contatori tag */}
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 1.5, pt: 1 }}>
          <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
            {plant.provincia && (
              <Chip
                label={plant.provincia}
                size="small"
                color="primary"
                variant="filled"
                sx={{ height: 22, fontSize: 11, fontWeight: 700 }}
              />
            )}
            {distLabel && (
              <Chip
                size="small"
                icon={<LocationOn sx={{ fontSize: '14px !important' }} />}
                label={distLabel}
                color={distance < 5 ? 'success' : distance < 20 ? 'warning' : 'default'}
                variant="outlined"
                sx={{ height: 22, fontSize: 11 }}
              />
            )}
          </Box>
        </Box>

        {/* Main content */}
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 1.5, pt: 0.5, pb: 1 }}>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography variant="subtitle1" fontWeight={700} noWrap>
              {codice}{citta ? ` — ${citta}` : ''}
            </Typography>
            <Typography variant="body2" color="text.secondary" noWrap>
              {plant.indirizzo || ''}
            </Typography>
          </Box>
          {meterCount > 0 && (
            <Chip
              icon={<Speed />}
              label={`${meterCount}`}
              color="primary"
              variant="outlined"
              sx={{ height: 28, fontSize: 13, fontWeight: 700, mr: 1 }}
            />
          )}
          <ArrowForwardIos sx={{ color: 'text.disabled', fontSize: 18, flexShrink: 0 }} />
        </Box>
      </CardContent>
    </Card>
  );
}

function haversine(lat1, lon1, lat2, lon2) {
  if (!lat2 || !lon2) return Infinity;
  const R = 6371;
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const a = Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLon / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}
